export const QUERY_OPTIONS = {
  STALE_TIME: 5_000,
  GC_TIME: 5_000,
  RETRY_COUNT: 3,
};

export const FETCH_OPTIONS = {
  timeout: 3_000,
  retry: 0,
};
